export type Locale = "lt" | "en";
export const messages = {
  lt: {
    title: "Aušra Mačiulytė",
    home: "Pradžia",
    about: "Apie",
    works: "Darbai",
    projects: "Projektai",
    articles: "Straipsniai",
    contact: "Kontaktai",
    navigation: "Pagrindinė navigacija",
    language: "Kalba",
    menu: "Meniu",
    closeMenu: "Uždaryti meniu",
    skip: "Pereiti prie turinio",
    intro: "Tapyba, keramika, piešiniai ir kūrybiniai projektai.",
    practice: "Kūryba ir veikla",
    selected: "Atrinkti darbai",
    allWorks: "Visi darbai",
    seeProjects: "Projektai",
    publications: "Publikacijos",
    worksLead: "Kūriniai iš autorės pateikto archyvo.",
    notFound: "Šis kūrinys nerastas.",
    all: "Visi",
    ceramics: "Keramika / objektai",
    painting: "Tapyba",
    drawings: "Piešiniai / eskizai",
    fluxus: "Fluxus / knygelė",
    other: "Kita",
    viewer: "Kūrinio peržiūra",
    openFullSize: "Atverti viso dydžio vaizdą",
    close: "Uždaryti",
    previous: "Ankstesnis",
    next: "Kitas",
    image: "Vaizdas",
    imageUnavailable: "Kūrinio nuotrauka kol kas nepasiekiama",
    projectsLead: "Kūrybos ir veiklos projektai.",
    articlesLead: "Tekstai ir publikacijos.",
    aboutLead: "Apie Aušrą Mačiulytę ir jos kūrybos kryptis.",
    // Neutral facts from am_web/mail_text/2026-09-25-13h23m23s-P2NWIEp--7-9-apie mane.txt.
    aboutOne:
      "Aušra Mačiulytė gimė 1975 m. Kaune. Jos tarpdisciplininė kūryba ir veikla apima tapybą, keramiką, piešinius, meno terapiją, žemės ir atminties meną, tekstus ir kūrybinius projektus.",
    aboutTwo:
      "Jos pateiktoje medžiagoje taip pat pristatomos meno terapijos, etnokultūrinės veiklos, lietuviškų runų ir baltiško masažo kryptys.",
    education: "Studijos",
    educationText:
      "1998 m. baigė Kauno taikomosios dailės mokyklą (keramika), 2011 m. — VDA tapybos bakalauro studijas Kaune, 2017 m. — VDA meno terapijos studijas, 2018 m. — VDA keramikos magistro studijas Vilniuje.",
    activity: "Kūrybinė veikla",
    activityText:
      "Aušra Mačiulytė dalyvavo keramikos ir tapybos parodose, rengė instaliacijas ir kultūrinius renginius, vedė meno terapijos užsiėmimus. Dirba pedagoginį darbą ir organizuoja kultūrines iniciatyvas, susijusias su Zarasų kraštu. 2022 m. Zarasų kultūros centrui ji sukūrė keramikos skulptūrą „Miškas“.",
    // Source: am_web/mail_text/2026-09-24-15h13m52s-P2Il--R--3-9-.txt.
    vjDruska: "VJ Druska (1989–2005)",
    vjDruskaText:
      "1989–2005 m. Aušra Mačiulytė dirbo žurnaliste, kino operatore ir kaip VJ Druska kūrė vaizdo instaliacijas renginiuose. Čia pateikiama išlikusi šios veiklos archyvinė medžiaga.",
    vjDruskaImage: "VJ Druska — archyvinė medžiaga",
    vjDruskaDocument: "Archyvinis lankstinukas / dokumentas (PDF)",
    vjDruskaDocumentNote:
      "Dokumentas iš dalies neįskaitomas; patikima data ir pavadinimas nenustatyti.",
    contactLead: "Dėl kūrybos ir projektų.",
    logoAlt: "Aušros Mačiulytės pieštas ženklas su varnomis",
    contactNote: "Parašykite žinutę ir nurodykite savo el. paštą atsakymui.",
    contactName: "Vardas",
    contactEmail: "Jūsų el. paštas",
    contactSubject: "Tema",
    contactMessage: "Žinutė",
    contactRequired: "Visi laukai privalomi.",
    contactSend: "Siųsti žinutę",
    contactSending: "Siunčiama…",
    contactChecking: "Tikrinama, ar galima išsiųsti žinutę…",
    contactDeliveryNote:
      "Žinutė siunčiama el. paštu. Atsakymui bus naudojamas jūsų el. paštas.",
    contactSent: "Žinutė išsiųsta!",
    contactAccepted: "Ačiū — pašto paslauga priėmė jūsų žinutę.",
    contactUnknown:
      "Brevo nepatvirtino, ar laišką išsiuntė — jis galėjo būti pristatytas. Patikrinkite gautuosius ir šlamšto aplanką prieš siųsdami dar kartą. Juodraštis liko formoje.",
    contactDeliveryFailed:
      "Žinutės išsiųsti nepavyko. Patikrinkite laukus ir bandykite dar kartą.",
    contactTransportUnknown:
      "Žinučių siuntimas šiuo metu nepasiekiamas. Bandykite vėliau.",
    contactPreviewNote:
      "Šioje peržiūroje žinutė bus išsaugota, tačiau el. laiškas nebus siunčiamas.",
    contactSavePreview: "Išsaugoti žinutę peržiūroje",
    contactSaving: "Išsaugoma…",
    contactSavedPreview:
      "Žinutė išsaugota. Šioje peržiūroje el. laiškas neišsiųstas.",
    contactUnknownButton: "Siuntos būsena nepatvirtinta",
    contactWhitespace: "Įrašykite tekstą, ne vien tarpus.",
    back: "Grįžti",
    read: "Skaityti",
    authorText: "Autorės pateiktas tekstas",
    page: "Puslapis",
    articleScanNote:
      "Visas publikacijos tekstas ir nuotraukos pateikiami originaliuose puslapiuose. Spustelėkite puslapį, kad perskaitytumėte viso dydžio vaizdą, arba atverkite PDF.",
    sourcePdf: "Atverti publikacijos PDF",
    articleSummary: "Interviu santrauka",
    articleOriginalPages: "Originalūs puslapiai",
    articleIssueNote:
      "Straipsnis pateikiamas viso laikraščio numerio PDF oficialiame „Draugo“ archyve.",
    document: "Dokumentas",
    footer: "Kūryba · tekstai · projektai",
  },
  en: {
    title: "Aušra Mačiulytė",
    home: "Home",
    about: "About",
    works: "Works",
    projects: "Projects",
    articles: "Articles",
    contact: "Contact",
    navigation: "Main navigation",
    language: "Language",
    menu: "Menu",
    closeMenu: "Close menu",
    skip: "Skip to content",
    intro: "Painting, ceramics, drawings and creative projects.",
    practice: "Art and practice",
    selected: "Selected works",
    allWorks: "All works",
    seeProjects: "Projects",
    publications: "Publications",
    worksLead: "Works from the artist's supplied archive.",
    notFound: "This work was not found.",
    all: "All",
    ceramics: "Ceramics / objects",
    painting: "Painting",
    drawings: "Drawings / sketches",
    fluxus: "Fluxus / booklet",
    other: "Other",
    viewer: "Artwork viewer",
    openFullSize: "Open full-size image",
    close: "Close",
    previous: "Previous",
    next: "Next",
    image: "Image",
    imageUnavailable: "Artwork photo currently unavailable",
    projectsLead: "Creative and practice-related projects.",
    articlesLead: "Writing and publications.",
    aboutLead: "About Aušra Mačiulytė and her practice.",
    aboutOne:
      "Aušra Mačiulytė was born in 1975 in Kaunas. Her interdisciplinary work spans painting, ceramics, drawing, art therapy, land and memory art, writing and creative projects.",
    aboutTwo:
      "Her supplied materials also present work in art therapy, ethnocultural activities, Lithuanian runes and Baltic massage.",
    education: "Studies",
    educationText:
      "She completed ceramics studies at Kaunas School of Applied Arts in 1998, a painting bachelor's degree at Vilnius Academy of Arts in Kaunas in 2011, art therapy studies in 2017 and a ceramics master's degree in Vilnius in 2018.",
    activity: "Practice",
    activityText:
      "Aušra Mačiulytė has taken part in ceramics and painting exhibitions, organized installations and cultural events, and led art-therapy sessions. She also teaches and organizes cultural initiatives connected with the Zarasai region. In 2022 she created the ceramic sculpture “Miškas” for Zarasai Culture Centre.",
    vjDruska: "VJ Druska (1989–2005)",
    vjDruskaText:
      "From 1989 to 2005, Aušra Mačiulytė worked as a journalist and film camera operator and created video installations at events as VJ Druska. The surviving archival material from this practice is presented here.",
    vjDruskaImage: "VJ Druska — archival material",
    vjDruskaDocument: "Archival flyer / document (PDF)",
    vjDruskaDocumentNote:
      "The document is partly illegible; a reliable date and title have not been established.",
    contactLead: "For enquiries about the work and projects.",
    logoAlt: "Aušra Mačiulytė's hand-drawn emblem with crows",
    contactNote:
      "Write your message and provide your email address for a reply.",
    contactName: "Name",
    contactEmail: "Your email",
    contactSubject: "Subject",
    contactMessage: "Message",
    contactRequired: "All fields are required.",
    contactSend: "Send message",
    contactSending: "Sending…",
    contactChecking: "Checking whether messages can be sent…",
    contactDeliveryNote:
      "Your message is sent by email. Your email address will be used for replies.",
    contactSent: "Message sent!",
    contactAccepted: "Thank you — the email service accepted your message.",
    contactUnknown:
      "Brevo could not confirm whether the email was sent—it may have been delivered. Check your inbox and spam folder before trying again. Your draft remains in the form.",
    contactDeliveryFailed:
      "Your message could not be sent. Check the fields and try again.",
    contactTransportUnknown:
      "Messaging is currently unavailable. Please try again later.",
    contactPreviewNote:
      "In this preview your message will be saved, but no email will be sent.",
    contactSavePreview: "Save message in preview",
    contactSaving: "Saving…",
    contactSavedPreview:
      "Your message was saved. No email was sent in this preview.",
    contactUnknownButton: "Send status unconfirmed",
    contactWhitespace: "Please enter text, not just spaces.",
    back: "Back",
    read: "Read",
    authorText: "Author-supplied text (in Lithuanian)",
    page: "Page",
    articleScanNote:
      "The complete publication text and photographs are shown in the original pages. Open a page to read the full-size image, or open the PDF.",
    sourcePdf: "Open publication PDF",
    articleSummary: "Interview summary",
    articleOriginalPages: "Original pages",
    articleIssueNote:
      "The article is available in the complete newspaper issue PDF in the official Draugas archive.",
    document: "Document",
    footer: "Art · writing · projects",
  },
} as const;
